import { Expose, Type } from "class-transformer";
import type { BONUSX_SUBSCRIPTION_TIERS } from "../../../../legacy/services/user-subscription/enums/bonusx-subscription-tiers.enum";
import type { DISCOUNT_UNIT } from "../../../../legacy/services/user-subscription/enums/discount-unit.enum";

export class UserSubscriptionDiscount {
  @Expose({ name: "discount" })
  amount!: number;

  @Expose({ name: "discountUnit" })
  unit!: DISCOUNT_UNIT;

  @Expose({ name: "item" })
  item!: string;
}

export class UserSubscriptionAccount {
  @Expose()
  subscriptionTier!: BONUSX_SUBSCRIPTION_TIERS | LooseString;

  @Expose()
  providerCode?: string;

  @Expose()
  @Type(() => Date)
  startDate?: Date;

  @Expose()
  @Type(() => Date)
  endDate?: Date;

  @Expose()
  @Type(() => Date)
  cancelledAt?: Date;

  @Expose()
  @Type(() => UserSubscriptionDiscount)
  discounts: UserSubscriptionDiscount[] = [];
}
